import React,{useState,useEffect,useCallback,useRef} from 'react';
import {RouteComponentProps} from 'react-router-dom'//yarn add @types/react-router-dom
import useReactRouter from 'use-react-router';
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import FaceIcon from '@material-ui/icons/HowToVote';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Chip from '@material-ui/core/Chip';
import Modal from '@material-ui/core/Modal';
import {Song} from './Inc';
import {Tools} from './Tools';
import {Styles} from './Styles';
import HaikuShow from './HaikuShow';
import TankaShow from './TankaShow';
import Ajax from './Ajax';

interface Props {
    userId: string,
}
interface RCProps extends RouteComponentProps<{}> {
	
}

let maxId = 0;
let minId = 0;
let modalPage = "";
let selectedSong:Song;
let cid:number;
let lastCount:number = 0;
const memoryLimit = 300;

const News = (props:Props)=> {
    Ajax.setUserId(props.userId);
    const classes = Styles.base();
    const [isModalOpen,setIsModalOpen] = useState(false);
    const defaultSongs:Song[] = [];
    const [songs,setSongs] = useState(defaultSongs);
    const refSongs = useRef(songs);
    useEffect(() => {
      refSongs.current = songs;
    }, [songs]);

	const rcp:RCProps = useReactRouter();
	const query = Tools.decodeQueryStrings(rcp.location.search);
	if( query["cid"] ){
	    cid = parseInt(query["cid"]);
	} else {
		cid = 0;
    }
        
    const load = useCallback(()=>{
        Ajax.send("news/list",{minId:minId},(res:any)=>{
            //console.log(res);
            if( res.ok ){
                if( res.songs.length>0 ){
                    lastCount = res.songs.length;
                    if( maxId===0 || maxId<res.songs[0].id ){
                        maxId = res.songs[0].id;
                    }
                    if( minId===0 || minId>res.songs[ res.songs.length-1 ].id ){
                        minId = res.songs[ res.songs.length-1 ].id;
                    }
                    if( refSongs.current.length>0 ){
                        setSongs(refSongs.current.concat(res.songs));
                    } else {
                        setSongs(res.songs);
                    }
                }
            }
        })
    },[]);

    const more = ()=>{
        load();
    }

    const openShow = (song:Song)=>{
        selectedSong = song;
        if( song.typeId==="1" ){
            modalPage = "tankashow";
        } else {
            modalPage = "haikushow";
        }
        setIsModalOpen(true);
    }

    const handleModalClose = ()=>{
		modalPage = "";
		setIsModalOpen(false);
    };

    const timeline = ()=>{
        if(!songs || songs.length===0){
            return (null);
        }
        return songs.map( (song:Song,index:number)=>{
            const key = song.id;
            return (
                <div key={key} className={classes.songBox}>
                    <div className={classes.songStatus} style={{textAlign:"center"}}>
                        <Fab size="small" color="primary" onClick={()=>openShow(song)}><FaceIcon/></Fab>
                        <Chip size="small" label={song.point} style={{backgroundColor:"#F9D401"}}/>
                    </div>
                    <div className={classes.songLines}>
                        {song.words1}<br/>
                        {song.words2}<br/>
                        {song.words3}<br/>
                        {song.typeId==="1" &&
                            <React.Fragment>
                            {song.words4}<br/>
                            {song.words5}<br/>
                            </React.Fragment>
                        }
                    </div>
                </div>
            )
        });
    }

    useEffect( ()=>{
        //console.log("news:effect");
        minId=0;
        maxId=0;
        const d:Song[] = [];
        setSongs(d);
        load();
    },[load,cid]);

    let isMore = true;
    if( songs.length>=memoryLimit || songs.length<10 || lastCount===0 ){
        isMore = false;
    }
	return (
		<div id="news" className={classes.mainRoot}>
            <div className={classes.timeline}>
                {timeline()}
                {isMore &&
                <Button variant="text" color="primary" style={{marginBottom:"2em",width:"100%"}} onClick={more}><ArrowDropDownIcon/></Button>
                }
                {songs.length===0 &&
                <div className={classes.timeline}>1+ only</div>
                }
            </div>
			<Modal
				aria-labelledby="simple-modal-title"
				aria-describedby="simple-modal-description"
				open={isModalOpen}
				onClose={handleModalClose}
			>
				<div style={Tools.getModalStyle()} className={classes.modal}>
                    {modalPage==="haikushow" &&
                    <HaikuShow userId={props.userId} close={handleModalClose} song={selectedSong}/>
                    }
                    {modalPage==="tankashow" &&
                    <TankaShow userId={props.userId} close={handleModalClose} song={selectedSong} hasStar={false}/>
                    }

	    		</div>
			</Modal>

    	</div>
	);
}

export default News;
